import { initAnimations } from './text-wipe-reveal.js';
import { initCursorButtonWrapper } from './cursor-button-wrapper.js';
import { initNavbarTheme } from './navbar-theme.js';
import { initSectionProjects } from './section_projects.js';
import { initTextScramble } from './text-scramble.js';
import { initTextVhs } from './section_main-hero.js';
import './section_expertise-compact.js';

document.addEventListener('DOMContentLoaded', () => {
  initAnimations();
  initCursorButtonWrapper();
  initNavbarTheme();
  initSectionProjects();
  initTextScramble();
  initTextVhs();
});
